import React from "react"
import * as AppConstants from "../../../../utility/AppConstants"
import "Css/table.css"
function TabAnomalie(props: any) {
    let elemNonDisponibile = AppConstants.ELEMENTO_NON_DISPONIBILE
    return (
        <React.Fragment>
            <tr className="tableStatIsa">
                <th className="th_punteggio_isa">
                    {" "}
                    {AppConstants.DATI_ANOMALIA_GESTIONE_BENI_STRUMENTALI}{" "}
                </th>
                {props.isCampo1 ? (
                    <td>
                        {" "}
                        {props.campo1 !== undefined
                            ? props.campo1.anomaliaBsNum
                            : elemNonDisponibile}{" "}
                    </td>
                ) : (
                    <React.Fragment />
                )}
                {props.isCampo2 ? (
                    <td>
                        {" "}
                        {props.campo2 !== undefined
                            ? props.campo2.anomaliaBsNum
                            : elemNonDisponibile}{" "}
                    </td>
                ) : (
                    <React.Fragment />
                )}
                {props.isCampo3 ? (
                    <td>
                        {" "}
                        {props.campo3 !== undefined
                            ? props.campo3.anomaliaBsNum
                            : elemNonDisponibile}{" "}
                    </td>
                ) : (
                    <React.Fragment />
                )}
                {props.isCampo4 ? (
                    <td>
                        {" "}
                        {props.campo4 !== undefined
                            ? props.campo4.anomaliaBsNum
                            : elemNonDisponibile}{" "}
                    </td>
                ) : (
                    <React.Fragment />
                )}
                {props.isCampo5 ? (
                    <td>
                        {" "}
                        {props.campo5 !== undefined
                            ? props.campo5.anomaliaBsNum
                            : elemNonDisponibile}{" "}
                    </td>
                ) : (
                    <React.Fragment />
                )}
            </tr>
            <tr className="tableStatIsa">
                <th className="th_punteggio_isa">
                    {" "}
                    {AppConstants.DATI_ANOMALIA_ATTIVITA_NON_INERENTI}
                </th>
                {props.isCampo1 ? (
                    <td>
                        {" "}
                        {props.campo1 !== undefined
                            ? props.campo1.punteggioAnomalieAttivitaNonInerenti
                            : elemNonDisponibile}{" "}
                    </td>
                ) : (
                    <React.Fragment />
                )}
                {props.isCampo2 ? (
                    <td>
                        {" "}
                        {props.campo2 !== undefined
                            ? props.campo2.punteggioAnomalieAttivitaNonInerenti
                            : elemNonDisponibile}{" "}
                    </td>
                ) : (
                    <React.Fragment />
                )}
                {props.isCampo3 ? (
                    <td>
                        {" "}
                        {props.campo3 !== undefined
                            ? props.campo3.punteggioAnomalieAttivitaNonInerenti
                            : elemNonDisponibile}{" "}
                    </td>
                ) : (
                    <React.Fragment />
                )}
                {props.isCampo4 ? (
                    <td>
                        {" "}
                        {props.campo4 !== undefined
                            ? props.campo4.punteggioAnomalieAttivitaNonInerenti
                            : elemNonDisponibile}{" "}
                    </td>
                ) : (
                    <React.Fragment />
                )}
                {props.isCampo5 ? (
                    <td>
                        {" "}
                        {props.campo5 !== undefined
                            ? props.campo5.punteggioAnomalieAttivitaNonInerenti
                            : elemNonDisponibile}{" "}
                    </td>
                ) : (
                    <React.Fragment />
                )}
            </tr>
        </React.Fragment>
    )
}
export default TabAnomalie
